import { VisibilityState } from '@tanstack/react-table';

export type AccountTableLayout = 'legacy' | 'new';

export const NEW_ACCOUNT_TABLE_CLASS =
    'overflow-hidden rounded-xl border border-stone-200 [&_thead]:bg-stone-50 [&_th]:h-12 [&_th]:text-[11px] [&_th]:font-semibold [&_th]:tracking-wider [&_th]:text-stone-500 [&_th]:uppercase [&_td]:h-14 [&_td]:border-stone-200 [&_td]:px-5 [&_td]:text-sm [&_td]:tabular-nums [&_td[data-column-id=marketValue]]:font-semibold';

export const accountTableClassName = (layout: AccountTableLayout) =>
    layout === 'new' ? NEW_ACCOUNT_TABLE_CLASS : 'rounded-md border';

// Default column order for all account tables
export const DEFAULT_ACCOUNT_TABLE_COLUMN_ORDER = [
    'symbol',
    'description',
    'assetClass',
    'assetType',
    'quantity',
    'side',
    'closePrice',
    'netExposure',
    'grossExposure',
    'costBasis',
    'pnlUnrealized',
    'returnUnrealized',
    'pnlRealized',
    'returnRealized',
    'term',
    'accruedInterest',
    'primaryExchange',
    'cusip',
    'isin',
    'subAssetType',
    'allocationType',
    'investmentSleeve',
    'maturityDate',
    'gicsCode',
    'gicsSector',
    'gicsIndustry',
];

// Default column visibility for all account tables (columns set to false are hidden)
export const DEFAULT_ACCOUNT_TABLE_COLUMN_VISIBILITY: VisibilityState = {
    marketValuePercentOfNav: false,
    underlyingSymbol: false,
    sId: false,
    scId: false,
    coId: false,
    ndvrChainId: false,
    minTick: false,
    expirationDate: false,
    firstNoticeDate: false,
    nav: false,
    settlementMethod: false,
    putCall: false,
    mic: false,
    contractMultiplier: false,
    sedol: false,
    brokerId: false,
    investmentAlgo: false,
    accountAlias: false,
    marketValue: false,
    tradeDate: false,
    priceMultiplier: false,
    country: false,
    issuer: false,
    coupon: false,
    issueDate: false,
};
